import React from "react";

import IndiaFlag from "./IndiaFlag";
import "./independence-day-navbar.css";

/* ------------------------------------------------------------------------
 * The small waving flag beside the WAY4TRACK wordmark.
 *
 * Only the wave and the sizing live here — the flag artwork itself comes from
 * the existing IndiaFlag, which is already the single source of truth for
 * every flag in the theme (3:2, equal bands, navy Chakra drawn as 12 full
 * diameters = 24 spokes). Re-drawing the SVG here would give the codebase two
 * flags that could drift apart.
 * ---------------------------------------------------------------------- */

export default function IndependenceFlag({ width = 17, className = "w4t-id-flag" }) {
    return (
        <span
            className={className}
            style={{ width, height: (width * 2) / 3 }}
            aria-hidden="true"
        >
            {/* Fewer, heavier spokes than the default 24: at 17px wide the
              * full Chakra fills in and reads as a navy dot. */}
            <IndiaFlag spokes={6} strokeWidth={6} chakraStroke={10} />
        </span>
    );
}
